/**
 * Préférences société qui pilotent le sideover web "Ajouter une activité"
 * (planning-team-activity-form) : quelles catégories y sont proposées, et quels motifs
 * sont épinglés en raccourci "Saisie rapide". Indépendant de `EvaCompanyMobileConfig`,
 * qui pilote le même genre de réglage côté app mobile.
 */
export class EvaCompanyWebActivityButtonsConfig {
  is_intervention_button_visible: boolean = true;
  is_project_button_visible: boolean = true;
  is_absence_button_visible: boolean = true;
  is_meal_break_button_visible: boolean = true;
  is_other_activity_button_visible: boolean = true;
  /** Valeurs de l'enum AbsenceType (ex. "SICKNESS", "VACATION") épinglées en "Saisie rapide". */
  pinned_absence_types: string[] = [];
  /** other_activity_motif_id d'OtherActivityMotif, propres à la société. */
  pinned_other_activity_motif_ids: string[] = [];
  /** Horodatage ISO (posé côté back) de la dernière modification. Null tant qu'aucun
   * enregistrement n'a jamais eu lieu. */
  buttons_updated_at: string | null = null;

  public static createInstance(jsonData: any): EvaCompanyWebActivityButtonsConfig {
    return Object.assign(new EvaCompanyWebActivityButtonsConfig(), jsonData ?? {});
  }
}
